import React from "react";
import Axios from 'axios'
import Cartela from '../_Components/Cartela'
import moment from 'moment';

export class ListaGanahdores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            cartelaSelecionada: null,
            tipoSelecionado: '',
            cartelas: [],
            kuadras: [],
            kinas: [],
            cruzadinhas: [],
            cheias: [],
            finas: [],
            giros: [],
            acc1: false,
            acc2: false,
            acc3: false,
            acc4: false,
            acc5: false,
            acc6: false,
            statusSorteio : true
        };
        this.statusSorteio()
        this.selecionarCartela = this.selecionarCartela.bind(this)


    }

    componentDidMount(){


    }


    
    formatDate(data) {
    return moment(data).add(0,'days').format('DD-MM-YYYY')
    }

    selecionarCartela(e){
        const gabarito = JSON.parse(e.target.accessKey);
        this.state.tipoSelecionado =  gabarito.tipo;
        this.setState({...this.state, cartelaSelecionada : gabarito.cartelaSorteada, tipoSelecionado : gabarito.tipo })
    }
    finasAtuais = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-finas-atuais");
            this.setState({finas: response.data});
            
        } catch (err) {
            console.log(err);
        }
    };
    cheiasAtuais = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-cheias-atuais");
            this.setState({cheias: response.data});
            
        } catch (err) {
            console.log(err);
        }
    };
    cruzadinhasAtuais = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-cruzadinhas-atuais");
            this.setState({cruzadinhas: response.data});
            
        } catch (err) {
            console.log(err);
        }
    };
    kuadrasAtuais = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-kuadras-atuais");
            this.setState({kuadras: response.data});
            
        } catch (err) {
            console.log(err);
        }
    };

    kinasAtuais = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-kinas-atuais");
            this.setState({kinas: response.data});
            
        } catch (err) {
            console.log(err);
        }
    };

    girosAtuais = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabarito-giro-atuais");
            this.setState({giros: response.data});
            
        } catch (err) {
            console.log(err);
        }
    };


    handlerAcc(acc1,acc2,acc3,acc4,acc5,acc6){
        this.setState({acc1,acc2,acc3,acc4,acc5,acc6})
    }

    resumeOfArray(currentArray){
        var arrNumbers = []
        currentArray.map(arr => {
            arr.numeros.map(n => {
                if(!arrNumbers.includes(n)){
                    arrNumbers.push(n)
                }
            })
        })
        return arrNumbers;
    }

    async statusSorteio(){
        try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/obter-sorteio-status");
            this.setState({statusSorteio : response.data.sorteioStatus});
            this.kuadrasAtuais();
            this.kinasAtuais();
            this.cruzadinhasAtuais();
            this.cheiasAtuais();
            this.finasAtuais();
            this.girosAtuais();
          } catch (err) {
            console.log(err);
          }
    }
    
    
    
    render() {
        if(this.state.user && this.state.user.perfil == 'MASTER' || !this.state.statusSorteio)
        return (
            <div>

                    <div class="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content" style={{marginTop: '-5em'}}>
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Detalhes da cartela</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    {this.state.cartelaSelecionada?

                        <div class="modal-body justify-content-center">
                            <Cartela class="ml-3" conferir={this.state.tipoSelecionado} cartela={this.state.cartelaSelecionada}></Cartela>
                        </div>
                    : ""}

                    <div class="modal-footer">
                        <button data-dismiss="modal" aria-label="Close" data-toggle="modal" data-target="#staticBackdrop" type="button" class="btn-fill btn btn-primary">Voltar</button>
                    </div>
                    </div>
                </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">
                                        Todos os ganhadores da semana
                                    </h4>
                                    <p className="card-category">
                                        Informações dos premios da rodada.
                                    </p>
                                </div>
                                <div className="card-body table-full-width table-responsive">




<button className="btAcordion" onClick={() => this.handlerAcc(true,false,false,false,false,false)}><div>SORTEIO KUADRA - {this.state.kuadras.length} cartela{this.state.kuadras.length != 1? "s" : ""} - Numeros : {this.state.kuadras.length > 0? this.resumeOfArray(this.state.kuadras).join()  : "aguardando..."}</div><div><i class="fas fa-caret-down"></i></div></button>
<div className={this.state.acc1? "bAccordion" : "d-none"}>

<table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                        <th>Data</th>
                                          <th>Tipo de batida</th>
                                            <th>Cartela</th>
                                            <th>Ganhador</th>
                                            {/* <th>Telefone</th> */}
                                            <th>Endereço</th>
                                            <th>Vendedor</th>
                                            <th>Gerente</th>
                                            <th>Preview</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.kuadras.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{this.formatDate(item.data)}</td>
                                                        <td>{item.tipo}</td>
                                                        <td>{item.cartelaSorteada.codigo}</td>
                                                        <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                        {/* <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td> */}
                                                        <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                        <td>{item.cambistaId ? item.cambistaId.nome == "Aplicativo"? 'Sorteflash App 2.0' :  item.cambistaId.nome : "Desconhecido"}</td>
                                                        <td>{item.gerenteId ? item.gerenteId.nome : "www.sorteflash.com"}</td>
                                                        <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

</div>
<button  className="btAcordion" onClick={() => this.handlerAcc(false,true,false,false,false,false)}><div>SORTEIO KINA - {this.state.kinas.length} cartela{this.state.kinas.length != 1? "s" : ""} - Numeros : {this.state.kinas.length > 0? this.resumeOfArray([...this.state.kuadras,...this.state.kinas]).join()  : "aguardando..."}</div><div><i class="fas fa-caret-down"></i></div></button>
<div className={this.state.acc2? "bAccordion" : "d-none"}>

<table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                        <th>Data</th>
                                          <th>Tipo de batida</th>
                                            <th>Cartela</th>
                                            <th>Ganhador</th>
                                            {/* <th>Telefone</th> */}
                                            <th>Endereço</th>
                                            <th>Vendedor</th>
                                            <th>Gerente</th>
                                            <th>Preview</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.kinas.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{this.formatDate(item.data)}</td>
                                                        <td>{item.tipo}</td>
                                                        <td>{item.cartelaSorteada.codigo}</td>
                                                        <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                        {/* <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td> */}
                                                        <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                        <td>{item.cambistaId ? item.cambistaId.nome == "Aplicativo"? 'Sorteflash App 2.0' :  item.cambistaId.nome : "Desconhecido"}</td>
                                                        <td>{item.gerenteId ? item.gerenteId.nome : "www.sorteflash.com"}</td>
                                                        <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

</div>
<button  className="btAcordion" onClick={() => this.handlerAcc(false,false,true,false,false,false)}><div>SORTEIO CRUZADINHA - {this.state.cruzadinhas.length} cartela{this.state.cruzadinhas.length != 1? "s" : ""} - Numeros : {this.state.cruzadinhas.length > 0? this.resumeOfArray([...this.state.kuadras,...this.state.kinas, ...this.state.cruzadinhas]).join()   : "aguardando..."}</div><div><i class="fas fa-caret-down"></i></div></button>
<div className={this.state.acc3? "bAccordion" : "d-none"}>
<table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                        <th>Data</th>
                                          <th>Tipo de batida</th>
                                            <th>Cartela</th>
                                            <th>Ganhador</th>
                                            {/* <th>Telefone</th> */}
                                            <th>Endereço</th>
                                            <th>Vendedor</th>
                                            <th>Gerente</th>
                                            <th>Preview</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.cruzadinhas.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{this.formatDate(item.data)}</td>
                                                        <td>{item.tipo}</td>
                                                        <td>{item.cartelaSorteada.codigo}</td>
                                                        <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                        {/* <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td> */}
                                                        <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                        <td>{item.cambistaId ? item.cambistaId.nome == "Aplicativo"? 'Sorteflash App 2.0' :  item.cambistaId.nome : "Desconhecido"}</td>
                                                        <td>{item.gerenteId ? item.gerenteId.nome : "www.sorteflash.com"}</td>
                                                        <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
</div>
<button  className="btAcordion" onClick={() => this.handlerAcc(false,false,false,true,false,false)}><div>SORTEIO CHEIA - {this.state.cheias.length} cartela{this.state.cheias.length != 1? "s" : ""} - Numeros : {this.state.cheias.length > 0? this.resumeOfArray([...this.state.kuadras,...this.state.kinas, ...this.state.cruzadinhas, ...this.state.cheias]).join()  : "aguardando..."}</div><div><i class="fas fa-caret-down"></i></div></button>
<div className={this.state.acc4? "bAccordion" : "d-none"}>

<table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                        <th>Data</th>
                                          <th>Tipo de batida</th>
                                            <th>Cartela</th>
                                            <th>Ganhador</th>
                                            {/* <th>Telefone</th> */}
                                            <th>Endereço</th>
                                            <th>Vendedor</th>
                                            <th>Gerente</th>
                                            <th>Preview</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.cheias.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{this.formatDate(item.data)}</td>
                                                        <td>{item.tipo}</td>
                                                        <td>{item.cartelaSorteada.codigo}</td>
                                                        <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                        {/* <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td> */}
                                                        <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                        <td>{item.cambistaId ? item.cambistaId.nome == "Aplicativo"? 'Sorteflash App 2.0' :  item.cambistaId.nome : "Desconhecido"}</td>
                                                        <td>{item.gerenteId ? item.gerenteId.nome : "www.sorteflash.com"}</td>
                                                        <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

</div>
<button   className="btAcordion" onClick={() => this.handlerAcc(false,false,false,false,true,false)}><div>SORTEIO FINA - {this.state.finas.length} cartela{this.state.finas.length != 1? "s" : ""}</div><div><i class="fas fa-caret-down"></i></div></button>
<div className={this.state.acc5? "bAccordion" : "d-none"}>

<table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                        <th>Data</th>
                                          <th>Tipo de batida</th>
                                            <th>Cartela</th>
                                            <th>Ganhador</th>
                                            {/* <th>Telefone</th> */}
                                            <th>Endereço</th>
                                            <th>Vendedor</th>
                                            <th>Gerente</th>
                                            <th>Preview</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.finas.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{this.formatDate(item.data)}</td>
                                                        <td>{item.tipo}</td>
                                                        <td>{item.cartelaSorteada.codigo}</td>
                                                        <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                        {/* <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td> */}
                                                        <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                        <td>{item.cambistaId ? item.cambistaId.nome == "Aplicativo"? 'Sorteflash App 2.0' :  item.cambistaId.nome : "Desconhecido"}</td>
                                                        <td>{item.gerenteId ? item.gerenteId.nome : "www.sorteflash.com"}</td>
                                                        <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

</div>
<button  className="btAcordion" onClick={() => this.handlerAcc(false,false,false,false,false,true)}><div>SORTEIO GIRO - {this.state.giros.length} cartela{this.state.giros.length != 1? "s" : ""}</div><div><i class="fas fa-caret-down"></i></div></button>
<div className={this.state.acc6? "bAccordion" : "d-none"}>

<table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                        <th>Data</th>
                                          <th>Tipo de batida</th>
                                            <th>Cartela</th>
                                            <th>Ganhador</th>
                                            {/* <th>Telefone</th> */}
                                            <th>Endereço</th>
                                            <th>Vendedor</th>
                                            <th>Gerente</th>
                                            <th>Preview</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.giros.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{this.formatDate(item.data)}</td>
                                                        <td>{item.tipo}</td>
                                                        <td>{item.cartelaSorteada.codigo}</td>
                                                        <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                        {/* <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td> */}
                                                        <td>{item.ganhadorId.endereco} - {item.ganhadorId.bairro} - {item.ganhadorId.cidade} - {item.ganhadorId.estado}</td>
                                                        <td>{item.cambistaId ? item.cambistaId.nome == "Aplicativo"? 'Sorteflash App 2.0' :  item.cambistaId.nome : "Desconhecido"}</td>
                                                        <td>{item.gerenteId ? item.gerenteId.nome : "www.sorteflash.com"}</td>
                                                        <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>

</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        else{
            return <div style={{width: '100%', height: "100%" , display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}><h3 style={{color: 'white', padding: '128px', backgroundColor: 'black'}}>Lista oficial só após o sorteio! Acompanhe no youtube <a href="https://www.youtube.com/c/SORTEFLASH">LINK DO YOUTUBE SORTEFLASH</a></h3></div>
        }
    }
}

export default ListaGanahdores;
